var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.96,
    height: 55.022,
    viewBox: "0 0 47.96 55.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f08089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#efab4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#e1d159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#4694ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#576298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76578f"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Intersection_31",
    "data-name": "Intersection 31",
    d: "M35.111,55.022v-1.4h9.781a1.664,1.664,0,0,0,1.654-1.542H35.111v-1.4H46.557v-.958a3.316,3.316,0,0,1-2.529-2.528H35.084v-1.4h7.653l-1.454-14.07H37.623L36.432,43.263l-1.4-.144,1.175-11.4H36.14a2.358,2.358,0,0,1,0-4.715h.474a4.265,4.265,0,1,1,5.676,0h.476a2.358,2.358,0,0,1,0,4.715h-.073l1.454,14.07h1.209v.7a1.9,1.9,0,0,0,1.9,1.9h.7v3.565a3.072,3.072,0,0,1-3.069,3.069Zm.074-25.664a.956.956,0,0,0,.955.955h6.626a.955.955,0,0,0,0-1.91H36.14A.956.956,0,0,0,35.185,29.358Zm1.406-5.532a2.862,2.862,0,1,0,2.862-2.861A2.865,2.865,0,0,0,36.591,23.826Zm-19.074,31.2a3.573,3.573,0,0,1-3.569-3.57V47.166h.7A2.456,2.456,0,0,0,17.1,44.714v-.7h1.393L20.267,26.44H20.05a2.73,2.73,0,0,1-.911-5.3V16.523H17.992v-1.4H19.03l-1.821-2.933v-.2A1.791,1.791,0,0,1,19,10.2h4.279V6.383H18.184v-1.4h5.094V0h1.4V4.979h5.095v1.4H24.682V10.2h3.733a1.792,1.792,0,0,1,1.79,1.79v.2l-1.822,2.933h1.585v1.4H28.82v4.614a2.73,2.73,0,0,1-.891,5.3h-.217l1.773,17.573h1.393v.7a2.456,2.456,0,0,0,2.452,2.452h.7v4.286a3.574,3.574,0,0,1-3.569,3.57Zm-2.166-3.57a2.168,2.168,0,0,0,2.166,2.167H30.464a2.169,2.169,0,0,0,2.166-2.167V51.41H15.351Zm0-2.947v1.5H32.63v-1.5a3.868,3.868,0,0,1-3.091-3.091H18.44A3.867,3.867,0,0,1,15.351,48.506ZM19.9,44.013h8.17L26.3,26.44H21.677Zm-1.16-20.331a1.319,1.319,0,0,0,1.3,1.355h7.879a1.33,1.33,0,0,0,0-2.66H20.05A1.307,1.307,0,0,0,18.745,23.682Zm1.8-2.707h6.876V16.523H20.542Zm-1.9-9.137,2.038,3.284h6.053l2.038-3.284a.388.388,0,0,0-.357-.236H19A.386.386,0,0,0,18.643,11.837ZM3.069,55.022A3.072,3.072,0,0,1,0,51.954V48.389H.7a1.9,1.9,0,0,0,1.9-1.9v-.7h1.21l1.453-14.07H5.195a2.358,2.358,0,1,1,0-4.715h.475a4.264,4.264,0,1,1,5.676,0h.475a2.358,2.358,0,1,1,0,4.715h-.072l1.175,11.4-1.4.144L10.336,31.716H6.676L5.222,45.786h7.654v1.4H3.931A3.315,3.315,0,0,1,1.4,49.717v.958H12.849v1.4H1.415A1.664,1.664,0,0,0,3.069,53.62h9.78v1.4Zm1.17-25.664a.956.956,0,0,0,.956.955H11.82a.955.955,0,1,0,0-1.91H5.195A.957.957,0,0,0,4.239,29.358Zm1.406-5.532a2.862,2.862,0,1,0,2.862-2.861A2.864,2.864,0,0,0,5.645,23.826Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.e020ea0fe533774feda528d6b00e5917.svg";
export { ForwardRef as ReactComponent };